import moment from 'moment'
import type {OpsOrderType, OrderStatus} from 'types/orderTypes'

const assertNever: () => never = () => {
  throw new Error('unsupported status')
}

export const getOrderStep = (orderStatus?: Exclude<OrderStatus, 'CANCELED'>) => {
  let step
  if (!orderStatus || orderStatus === 'ACCEPTED' || orderStatus === 'ORDERED') {
    step = 0
  } else if (orderStatus === 'ASSIGNED') {
    step = 1
  } else if (orderStatus === 'REVIEWING') {
    step = 2
  } else if (orderStatus === 'COMPLETED') {
    step = 3
  } else {
    assertNever()
  }

  return step
}

export type CDADisplayStatus =
  | 'ORDERED'
  | 'ASSIGNED'
  | 'REVIEWING'
  | 'COMPLETED'
  | 'CANCEL_REQUESTED'
  | 'CANCELED'
  | 'ON_HOLD'
  | 'ON_HOLD_REMOVING'

export const getViewStatus = (order: OpsOrderType) => {
  let orderStatus: CDADisplayStatus
  if (order.status?.orderStatus === 'CANCELED') {
    orderStatus = 'CANCELED'
  } else if (order.status?.cancel?.cancelRequested) {
    orderStatus = 'CANCEL_REQUESTED'
  } else if (order.status?.hold) {
    if (order.status.hold.holdRemovalRequested) {
      orderStatus = 'ON_HOLD_REMOVING'
    } else {
      orderStatus = 'ON_HOLD'
    }
  } else if (!order.status?.orderStatus || order.status.orderStatus === 'ACCEPTED') {
    orderStatus = 'ORDERED'
  } else {
    orderStatus = order.status.orderStatus
  }

  return orderStatus
}

export const getDescription = (order: OpsOrderType) => {
  const momentFormat = 'MMM DD, YYYY, hA'
  if (order.status?.orderStatus === 'COMPLETED') {
    return `Delivered on ${moment(order.completedDate).format(momentFormat)}.`
  } else if (order.status?.orderStatus !== 'CANCELED') {
    const estimatedDeliveryDate = order.estimatedCompletionDate ?? order.dueDate
    return `Estimated delivery date is ${moment(estimatedDeliveryDate).format(momentFormat)}.`
  }
}
